module.exports = __webpack_public_path__ + "img/xqgl1.3f879423.png";